import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { clearToken } from '../api';

const navItems = [
  { to: '/', label: 'Dashboard', icon: '🏠' },
  { to: '/ads/create-images', label: 'Create Images', icon: '🖼️' },
  { to: '/greetings/create', label: 'Greeting Creative', icon: '🎉' },
  { to: '/font-manager', label: 'Font Manager', icon: 'Aa' },
  { to: '/ads/gallery', label: 'Gallery', icon: '🌈' },
  { to: '/openai-usage', label: 'OpenAI Usage', icon: '🤖' },
  { to: '/openai-cost-analysis', label: 'OpenAI Cost & Usage Analysis', icon: '💰' },
  { to: '/clients', label: 'Clients', icon: '👥' },
  { to: '/ads/new', label: 'New Ad Idea', icon: '➕' },
  { to: '/ads/status', label: 'Ads Status', icon: '📊' },
];

export default function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sidebar_collapsed') === 'true');

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebar_collapsed', String(next));
      return next;
    });
  };
  const navigate = useNavigate();

  const handleLogout = () => {
    clearToken();
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen bg-brand-bg">
      <aside
        className={`${collapsed ? 'w-16' : 'w-56'} transition-all duration-200 bg-white border-r border-gray-200 flex flex-col`}
      >
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200">
          {!collapsed && (
            <span className="font-bold text-brand-purple text-lg">Shahi Raj Ads</span>
          )}
          <button
            onClick={toggleCollapsed}
            className="text-gray-500 hover:text-brand-purple"
          >
            ☰
          </button>
        </div>

        <nav className="flex-1 py-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2 mx-2 rounded-lg text-sm font-medium ${
                  isActive
                    ? 'bg-brand-hero text-brand-purple'
                    : 'text-gray-600 hover:bg-gray-100'
                }`
              }
            >
              <span>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <button
            onClick={handleLogout}
            className="text-sm text-gray-500 hover:text-brand-orange"
          >
            {collapsed ? '⏻' : 'Log out →'}
          </button>
        </div>
      </aside>

      <main className="flex-1 p-8 overflow-auto">{children}</main>
    </div>
  );
}
